module.exports = __webpack_public_path__ + "static/img/flexible-selected-bg.d924302a.png";